module.exports = __webpack_public_path__ + "img/t3-c14.1e8c2843.png";